import { Action } from '@ngrx/store';
import { IUserData } from '@app/profile/main/details';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';
import { IUserSettings } from '@app/profile/settings/settings';
import { IPackItem } from '@app/certificates/packs/packs';
import { INomenclature } from '../nomenclature/nomenclature';

export enum AuthActionTypes {
  LOGIN = '[Auth] Login',
  LOGOUT = '[Auth] Logout',
  LOGIN_SUCCESS = '[Auth] Login success',
  LOGIN_FAIL = '[Auth] Login fail',
  ALTERNATIVE_LOGIN_REMINDED = '[Auth] Alternative login reminded',
  ALTERNATIVE_LOGIN_REMINDED_SUCCESS = '[Auth] Alternative login reminded success',
}

export type AuthCallbackType = (res: boolean | ISpringResponseBody) => void;

export class ActionAuthLogin implements Action {
  readonly type = AuthActionTypes.LOGIN;
  constructor(public payload?: { url?: string, loginWithQR?: boolean, callback?: AuthCallbackType }) { }
}

export class ActionAuthLogout implements Action {
  readonly type = AuthActionTypes.LOGOUT;
  constructor(public isSessionEnded: boolean) { }
}

export class ActionAuthLoginSuccess implements Action {
  readonly type = AuthActionTypes.LOGIN_SUCCESS;
  constructor(public payload: { auth?: IAuthLoginData, isEmergencyLogin?: boolean }) { }
}

export class ActionAuthLoginFail implements Action {
  readonly type = AuthActionTypes.LOGIN_FAIL;
}

export class ActionAuthAlternativeLoginReminded implements Action {
  readonly type = AuthActionTypes.ALTERNATIVE_LOGIN_REMINDED;
}

export class ActionAuthAlternativeLoginRemindedSuccess implements Action {
  readonly type = AuthActionTypes.ALTERNATIVE_LOGIN_REMINDED_SUCCESS;
}

export type AuthActions =
  ActionAuthLogin |
  ActionAuthLogout |
  ActionAuthLoginSuccess |
  ActionAuthAlternativeLoginReminded |
  ActionAuthAlternativeLoginRemindedSuccess |
  ActionAuthLoginFail;

export const initialState: IAuthState = {
  isAuthenticated: false
};

export const selectorAuth = state => state.auth as IAuthState;

export function authReducer(state: IAuthState = initialState, action: AuthActions): IAuthState {
  switch (action.type) {

    case AuthActionTypes.LOGIN:
      return { ...state, isAuthenticated: false };

    case AuthActionTypes.LOGIN_SUCCESS:
      const data = action.payload.auth;
      return {
        ...state,
        isAuthenticated: true,
        userData: data.userData
      };

    case AuthActionTypes.LOGIN_FAIL:
      return { ...state, isAuthenticated: false };

    case AuthActionTypes.ALTERNATIVE_LOGIN_REMINDED:
      return { ...state, alternativeLoginReminded: true };

    case AuthActionTypes.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        userData: null,
        alternativeLoginReminded: null,
        alternativaLoginRemindedSuccess: null
      };

    case AuthActionTypes.ALTERNATIVE_LOGIN_REMINDED_SUCCESS:
      return { ...state, alternativaLoginRemindedSuccess: true };

    default:
      return state;
  }

}

export interface IAuthState {
  isAuthenticated: boolean;
  userData?: IUserData;
  alternativeLoginReminded?: boolean;
  alternativaLoginRemindedSuccess?: boolean;
}

export interface IAuthLoginData extends IAuthState {
  settings: IUserSettings;
  packs: IPackItem[];
  nomenclature: INomenclature;
}
